/**
 * @file Defines the data contracts for the two-phase PDF processing API.
 */
// =================================================================
// NEW TYPES FOR POLLING ARCHITECTURE
// =================================================================
/**
 * Defines the various states of a PDF processing attempt.
 * This is the Single Source of Truth shared between the frontend and backend.
 * Its values strictly correspond to the CHECK constraint on the `status` column
 * of the `pdf_processing_attempts` table in the database.
 */
export var PdfProcessingAttemptStatus;
(function (PdfProcessingAttemptStatus) {
    /**
     * The file is being uploaded to temporary storage.
     * This is the initial state of the processing flow.
     */
    PdfProcessingAttemptStatus["UPLOADING"] = "uploading";
    /**
     * The file upload is complete, credits have been deducted, and the job
     * has been submitted to the cloud function for processing.
     * This is the most common "in-progress" state during polling.
     */
    PdfProcessingAttemptStatus["PENDING"] = "pending";
    /**
     * The cloud function has successfully processed the file, and the result
     * is ready for download. This is an intermediate state before the user
     * confirms the download.
     */
    PdfProcessingAttemptStatus["PROCESSED"] = "processed";
    /**
     * The user has successfully downloaded the result and confirmed it.
     * This is a final state, after which the result file is deleted.
     */
    PdfProcessingAttemptStatus["COMPLETED"] = "completed";
    /**
     * The processing failed at any step, either in the cloud function or before.
     * This is a final state that should trigger a compensation flow (e.g., refund).
     */
    PdfProcessingAttemptStatus["FAILED"] = "failed";
    /**
     * The compensation flow (e.g., refund) following a FAILED state also failed.
     * This is a critical final state that requires manual intervention.
     */
    PdfProcessingAttemptStatus["REFUND_FAILED"] = "refund_failed";
})(PdfProcessingAttemptStatus || (PdfProcessingAttemptStatus = {}));
//# sourceMappingURL=processing.types.js.map